<template>
  <div
    class="uk-position-relative uk-visible-toggle rwd"
    tabindex="-1"
    uk-slideshow="autoplay: true;autoplay-interval: 5000;"
  >
    <ul class="uk-slideshow-items">
      <li
        class="slideshow-items video_wrap"
        v-for="video in props.data"
        :key="video.vid"
      >
        <div class="video_group_rwd">
          <div class="video_item">
            <div class="news_video" v-html="video.originalFilePath"></div>
          </div>
        </div>
        <router-link
          class="txt_link"
          :to="{ name: 'VideoInner', params: { id: video.vid } }"
          style="display: block"
          title="影片專區文章"
        >
          <div class="txt_area">
            <p :style="{ fontSize: fontSize.p + 'em' }" class="message">
              {{ video.title }}
            </p>
          </div>
        </router-link>
      </li>
    </ul>
    <a
      title="輪播左邊按鈕"
      class="uk-position-center-left uk-position-small"
      href="#"
      uk-slidenav-previous
      uk-slideshow-item="previous"
    >
      <span class="forFreeGo">&nbsp;</span>
    </a>
    <a
      title="輪播右邊按鈕"
      class="uk-position-center-right uk-position-small"
      href="#"
      uk-slidenav-next
      uk-slideshow-item="next"
    >
      <span class="forFreeGo">&nbsp;</span>
    </a>
  </div>
</template>

<script>
//  無障礙文字子層引入設定
import { inject } from "vue";
export default {
  name: "VideoCarousel",
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  setup(props) {
    let fontSize = inject("fontSize");
    return { props, fontSize };
  },
};
</script>

<style lang="scss" scoped>
.video_group {
  @include flex_between();
  flex-wrap: wrap;
  .video_item {
    width: 100%;
    // margin: 15px 0;
  }
  .news_video {
    position: relative;
    width: 100%;
    height: 0;
    margin: 0 auto;
    p {
      text-align: left;
    }
    padding-bottom: 56.25%;
    iframe {
      border-radius: 10px;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
.video_group_rwd {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .video_item {
    position: relative;
    width: 100%;
    height: 100%;
    padding-bottom: 56.25%;
    :deep iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
.message {
  text-align: left;
  padding: 0 10px;
}

.uk-position-relative {
  p {
    color: $black_color;
    padding: 10px 0;
  }
  .txt_link {
    padding: 0;
    margin: 0;
  }
}
</style>
